<template>
    <div>
        <div class="craft">
            <div class="part-one">
                <div class="base-title">
                    <div class="part-one-content">
                        <img class="part-one-title-img" src="../assets/imgs/craft/part-1-title.png" alt="" />
                        <div class="part-text part-one-title" style="margin-left:0rem;">
                            为深入实施人才强市战略，加快建设全国创新人才高地，贯彻落实“成都人才新政2.0版”，实施海外留学生回引工程，吸引更多优秀海外高校应届毕业生来蓉创新创业。
                        </div>
                    </div>
                </div>
            </div>
            <div class="part-two">
                <img src="../assets/imgs/23/part-2-title.png" class="part-two-title-img" />
                <div class="part-two-content">优秀海外高校应届毕业生。</div>
            </div>
            <div class="part-three">
                <img src="../assets/imgs/23/part-3-title.png" class="part-two-title-img" />
                <div class="main-content">
                    <div class="part-four-items">
                        （一）取得本科学历学位的优秀海外高校应届毕业生，可申请最高2万元一次性创新创业补贴。
                    </div>
                    <div class="part-four-items">
                        （二）取得硕士研究生学历学位的优秀海外高校应届毕业生，可申请最高4万元一次性创新创业补贴。
                    </div>
                    <div class="part-four-items">
                        （三）取得博士研究生学历学位的优秀海外高校应届毕业生，可申请最高6万元一次性创新创业补贴。
                    </div>
                </div>
                <div style="
                            color: #3d5aa3ff;
                            font-size: 0.26rem;
                            text-align: left;
                            line-height: 1.5;
                            margin-top: 0.25rem;
                        ">
                   注：优秀海外高校毕业生创新创业补贴与博士后人才生活资助、急需紧缺专业技术人才安家补贴、急需紧缺技能人才安家补贴等政策均不能重复享受
                </div>
            </div>
            <div class="part-three">
                <img src="../assets/imgs/23/part-4-title.png" class="part-two-title-img" />
                <div class="main-content">
                    <div class="part-four-items">
                        具有中国国籍、获得世界大学排名前50的海外高校（以下简称优秀海外高校）学历学位的毕业生，毕业后24个月内在本市创业或在本市从事相关创新工作。
                    </div>
                    <div class="part-four-items">
                        优秀海外高校指市级有关部门参照QS、THE、U.S.News的世界大学综合排名前50名单商定的年度海外高校名单（如《2021年度部分海外高校目录（仅供创新创业补贴使用）》）。
                    </div>
                </div>
            </div>
            <div class="part-four">
                <img src="../assets/imgs/23/part-5-title.png" class="part-two-title-img" />
                <div class="main-content">
                    <div class="part-four-items">
                        <div class="title-bg">集中申报（以2021年度为例）</div>
                        <div class="part-four-content1">
                            <p>
                                年度申报通知发放后，符合条件的申请人向单位工商注册地的区（市）县人社部门递交以下以下申报材料：
                            </p>
                            <p>1.属自主创业</p>
                            <p>
                                （1）《优秀海外高校应届毕业生创新创业补贴申请表》；
                            </p>
                            <p>
                                （2）本人所创办企业的营业执照复印件，完税证明的原件及复印件；
                            </p>
                            <p>
                                （3）身份证、学历学位证书、学历学位鉴定证明、社保卡（带银行金融功能）或银行账户等材料的原件及复印件；
                            </p>
                            <p>2.属在企业从事相关创新工作</p>
                            <p>
                                （1）《优秀海外高校应届毕业生创新创业补贴申请表》；
                            </p>
                            <p>（2）企业营业执照复印件；</p>
                            <p>（3）本人从事相关创新工作的证明资料；</p>
                            <p>
                                （4）本人身份证、学历学位证书、学历学位鉴定证明（教育部留学服务中心认证的《国外学历学位认证书》、《港澳台学历学位认证书》或四川省人社厅专家服务中心认证的《四川省海外留学人员证书》）、社保卡（带银行金融功能）或银行账户、劳动合同（1年及以上）、社保缴纳证明（6个月及以上）等材料的原件及复印件。
                            </p>
                        </div>
                    </div>
                    <div class="part-four-items" style="border: none; margin-bottom: 0">
                        <div class="title-bg2">区（市）县审核备案</div>
                        <div class="part-four-content1">
                            <p>
                                区（市）县人社部门会同财政部门对申报材料进行审核、公示、确定通过人员名单，并报送市人社局备案。
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="contact">
                <img class="top" src="./../assets/imgs/76/title-5.png" alt="" />
                <div class="content">
                    <div class="unit" style="margin-top: 0;">
                        <span class="label">责任单位：</span>
                        成都市人力资源和社会保障局专业技术人员服务管理处
                    </div>
                    <div class="number" style="margin-top: 0.1rem;">
                        <span class="label">政策咨询电话：</span>
                        <div>
                            <a href="tel:028-61888121">028-61888121</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="part-five">
                <div style="position: relative;display: flex;align-items: center;">
                    <img style="width: 1.94rem; height: 1.94rem" src="../assets/imgs/23/code-1-1.png" alt="" />
                    <img src="../assets/imgs/23/code-1.png" style="width: 4.07rem; height: 2.78rem" alt="" />
                </div>
            </div>
            <!-- <div class="bottom-info">责任单位：各区（市）县人社部门</div> -->
            <!-- <div class="bottom-info" style="margin-top: 0.15rem">
                扫描以上二维码，查看附件获取咨询电话
            </div> -->
            <!-- <bottom unit="各区（市）县人社部门"></bottom> -->
        </div>
        <call phone="028-61888121"></call>
    </div>
</template>

<script>
import call from "../components/call.vue";

export default {
    name: "craft",
    components: {
        call,
    },
    data() {
        return {};
    },
    created() { },
    mounted() { },
    computed: {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.craft {
    background: #0839b7;
    overflow: hidden;
    padding: 0.24rem 0.12rem;
    padding-bottom: 1.65rem;
    box-sizing: border-box;
    width: 100vw;
    height: 100vh;
    overflow-y: auto;

    .part-title {
        font-size: 0.34rem;
        //font-family:: PingFang SC-Bold, PingFang SC;
        font-weight: bold;
        color: #333333;
        position: relative;

        &::before {
            position: absolute;
            content: "";
            width: 0.28rem;
            height: 0.28rem;
            border-radius: 50%;
            background: none;
            border: 0.06rem solid #ff6d60;
            box-sizing: border-box;
            top: 0.08rem;
            left: -0.2rem;
        }
    }

    .part-text {
        font-size: 0.26rem;
        //font-family:: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #4e4e4e;
        line-height: 0.44rem;
        text-align: left;
    }

    .part-one {
        width: 7.5rem;
        height: 7.3rem;
        margin: 0 auto;

        .base-title {
            width: 7.26rem;
            height: 5.6rem;
            background: url(../assets/imgs/23/base-title.png);
            background-size: 100% 100%;
            position: relative;

            .part-one-content {
                width: 6.85rem;
                // height: 4.3rem;
                background: #ffffff;
                border-radius: 10px;
                position: absolute;
                top: 4.02rem;
                left: 0.22rem;
                padding-left: 0.36rem;
                padding-right: 0.37rem;
                box-sizing: border-box;
                padding-bottom: 0.35rem;

                .part-one-title-img {
                    position: absolute;
                    top: -0.32rem;
                    left: 0;
                    width: 6.86rem;
                    height: 1.12rem;
                }

                .part-one-title {
                    margin-top: 0.98rem;
                    text-align: left;
                    margin-left: 0.34rem;
                }

                .part-one-text {
                    margin-top: 0.16rem;
                }
            }
        }
    }

    .part-two-title-img {
        width: 7.03rem;
        height: 1.37rem;
        top: 0;
        left: -0.18rem;
        position: absolute;
    }

    .part-two {
        margin-left: 0.02rem;
        width: 6.85rem;
        margin-top: 0.22rem;
        background: #e8eeff;
        border-radius: 10px;
        box-sizing: border-box;
        margin: 0 auto;
        margin-top: 0.22rem;
        border: 0.00001px solid transparent;
        position: relative;

        .part-two-content {
            margin-top: 1.2rem;
            width: 100%;
            padding: 0.35rem;
            background: #ffffff;
            border-radius: 10px;
            box-sizing: border-box;
            font-size: 0.26rem;
            //font-family:: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #4e4e4e;
            line-height: 0.44rem;
            text-align: left;
        }
    }

    .part-three {
        width: 6.85rem;
        background: #e8eeff;
        border-radius: 10px;
        margin-left: 0.02rem;
        margin-top: 0.22rem;
        box-sizing: border-box;
        margin: 0 auto;
        margin-top: 0.22rem;
        border: 0.00001px solid transparent;
        position: relative;
        padding: 1.44rem 0.25rem 0.35rem 0.25rem;

        .part-four-title {
            text-align: left;
            margin-left: 0.35rem;

            &::before {
                position: absolute;
                content: "";
                width: 0.28rem;
                height: 0.28rem;
                border-radius: 50%;
                background: none;
                border: 0.06rem solid #ff6d60;
                box-sizing: border-box;
                top: 0.08rem;
                left: -0.38rem;
            }
        }

        .main-content {
            margin-top: 0.1rem;
            width: 6.35rem;
            background: #ffffff;
            border-radius: 10px;
            box-sizing: border-box;
            padding-top: 0.5rem;
            padding-left: 0.35rem;
            padding-right: 0.31rem;

            .part-four-items {
                box-sizing: border-box;
                position: relative;
                margin-bottom: 0.15rem;
                font-size: 0.26rem;
                //font-family:: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
                color: #4e4e4e;
                line-height: 0.44rem;
                text-align: left;
                padding-bottom: 0.25rem;
            }
        }
    }

    .part-four {
        width: 6.85rem;
        background: #e8eeff;
        border-radius: 10px;
        margin-left: 0.02rem;
        margin-top: 0.22rem;
        box-sizing: border-box;
        display: inline-block;
        position: relative;
        padding: 1.2rem 0.25rem 0.35rem 0.25rem;

        .part-four-title {
            text-align: left;
            margin-left: 0.35rem;

            &::before {
                position: absolute;
                content: "";
                width: 0.28rem;
                height: 0.28rem;
                border-radius: 50%;
                background: none;
                border: 0.06rem solid #ff6d60;
                box-sizing: border-box;
                top: 0.08rem;
                left: -0.38rem;
            }
        }

        .main-content {
            margin-top: 0.34rem;
            width: 6.35rem;
            // min-height: 15.3rem;
            background: #ffffff;
            border-radius: 10px;
            box-sizing: border-box;
            padding-top: 0.8rem;
            padding-left: 0.35rem;
            padding-right: 0.31rem;
            // padding-bottom: 0.5rem;

            .part-four-items {
                box-sizing: border-box;
                border-left: 0.02rem dashed #739bfe;
                margin-bottom: 0.6rem;
                padding-left: 0.33rem;
                padding-top: 0.2rem;
                position: relative;
                font-size: 0.26rem;
                //font-family:: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
                color: #4e4e4e;
                line-height: 0.44rem;
                text-align: left;
                padding-bottom: 0.25rem;

                .title-bg {
                    position: absolute;
                    width: 3.31rem;
                    height: 0.6rem;
                    top: -0.6rem;
                    left: -0.25rem;
                    display: inline-flex;
                    align-items: center;
                    font-size: 0.3rem;
                    //font-family:: PingFang SC-Bold, PingFang SC;
                    font-weight: bold;
                    color: #3d5aa3;
                    padding-left: 0.58rem;
                    background: url(../assets/imgs/craft/part4-1.png);
                    background-size: 100% 100%;
                    white-space: nowrap;
                    line-height: 0.6rem;
                }

                .title-bg2 {
                    position: absolute;
                    width: 3.31rem;
                    height: 0.6rem;
                    top: -0.6rem;
                    left: -0.25rem;
                    display: inline-flex;
                    align-items: center;
                    font-size: 0.3rem;
                    //font-family:: PingFang SC-Bold, PingFang SC;
                    font-weight: bold;
                    color: #3d5aa3;
                    padding-left: 0.58rem;
                    white-space: nowrap;
                    background: url(../assets/imgs/craft/part4-2.png);
                    background-size: 100% 100%;
                    line-height: 0.6rem;

                }

                .title-bg3 {
                    background: url(../assets/imgs/craft/part4-3.png);
                    background-size: 100% 100%;
                }

                .title-bg4 {
                    background: url(../assets/imgs/craft/part4-4.png);
                    background-size: 100% 100%;
                }

                .title-bg5 {
                    background: url(../assets/imgs/craft/part4-5.png);
                    background-size: 100% 100%;
                }

                .title-bg6 {
                    background: url(../assets/imgs/craft/part4-6.png);
                    background-size: 100% 100%;
                }

                .inside-title {
                    font-weight: 800;
                }

                .part-four-content1 {
                    margin-bottom: 0.2rem;

                    p {
                        margin: 0.01rem;
                    }
                }
            }
        }
    }

    .part-five {
        margin: auto;
        margin-top: 0.25rem;
        width: 6.86rem;
        box-sizing: border-box;
        border-radius: 13px;
        margin-bottom: 0.32rem;
        background-color: #fff;
        padding: 0.35rem;
        padding-top: 0.45rem;
        text-align: left;
        display: flex;
        justify-content: space-between;

        p {
            font-size: 0.26rem;
            color: #4e4e4eff;
        }

        a {
            font-size: 0.26rem;
            word-break: break-word;
            line-height: 1.5;
            display: inline-block;
        }
    }

    .bottom-info {
        font-size: 0.24rem;
        //font-family:: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #97a9d9;
    }
}
</style>
